/** Badge definitions — display info for all achievement badges. */

export interface BadgeDef {
  key: string;
  icon: string;
  nameEs: string;
  nameEn: string;
  descEs: string;
  descEn: string;
}

export const BADGE_DEFS: Record<string, BadgeDef> = {
  first_lesson: {
    key: "first_lesson",
    icon: "🎓",
    nameEs: "Primeros Pasos",
    nameEn: "First Steps",
    descEs: "Completa tu primera lección",
    descEn: "Complete your first lesson",
  },
  perfect_quiz: {
    key: "perfect_quiz",
    icon: "🎯",
    nameEs: "Francotirador",
    nameEn: "Sharpshooter",
    descEs: "Consigue 3/3 en un quiz",
    descEn: "Score 3/3 on a quiz",
  },
  streak_7: {
    key: "streak_7",
    icon: "🔥",
    nameEs: "Guerrero Semanal",
    nameEn: "Week Warrior",
    descEs: "Racha de 7 días",
    descEn: "7-day streak",
  },
  streak_30: {
    key: "streak_30",
    icon: "💪",
    nameEs: "Dedicación",
    nameEn: "Dedication",
    descEs: "Racha de 30 días",
    descEn: "30-day streak",
  },
  streak_100: {
    key: "streak_100",
    icon: "👑",
    nameEs: "Leyenda",
    nameEn: "Legend",
    descEs: "Racha de 100 días",
    descEn: "100-day streak",
  },
  level_1: {
    key: "level_1",
    icon: "📚",
    nameEs: "Novato",
    nameEn: "Rookie",
    descEs: "Completa el Nivel 1",
    descEn: "Complete Level 1",
  },
  level_4: {
    key: "level_4",
    icon: "🧮",
    nameEs: "Mago Matemático",
    nameEn: "Math Wizard",
    descEs: "Completa el Nivel 4",
    descEn: "Complete Level 4",
  },
  level_7: {
    key: "level_7",
    icon: "🏆",
    nameEs: "Graduado",
    nameEn: "Graduate",
    descEs: "Completa los 7 niveles",
    descEn: "Complete all 7 levels",
  },
  reviews_50: {
    key: "reviews_50",
    icon: "🔄",
    nameEs: "Repasador",
    nameEn: "Review Champion",
    descEs: "50 repasos completados",
    descEn: "50 spaced reviews completed",
  },
  perfect_level: {
    key: "perfect_level",
    icon: "💎",
    nameEs: "Perfeccionista",
    nameEn: "Perfectionist",
    descEs: "100% en quizzes de un nivel",
    descEn: "100% quiz scores across a level",
  },
  speed_learner: {
    key: "speed_learner",
    icon: "⚡",
    nameEs: "Veloz",
    nameEn: "Speed Learner",
    descEs: "Completa una lección en menos de 5 min",
    descEn: "Complete a lesson in under 5 minutes",
  },
};

export const ALL_BADGE_KEYS = Object.keys(BADGE_DEFS);
